import {DialogDeleteConfigurationState} from './dialog-delete-configuration.state';


export const dialogDeleteConfigurationStateInitial: DialogDeleteConfigurationState = {
  isOpen: false,
};
